import React from 'react';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import SignedImage from '../../System/SignedImage';

const WelcomePwaTipsItem = ({item}) => {
    const {defaultIcon, iconPath, titleKey} = item;
    const localizedStrings = getLocalizedStrings();

    if (!localizedStrings[titleKey]) return null;

    return (
        <li className='flex items-center gap-1'>
            <div className='h-12 w-12 shrink-0'>
                <SignedImage
                    imgClassName='w-full h-full object-contain'
                    mediaData={iconPath}
                    defaultImage={defaultIcon}
                    signIfNull
                    isThumbnailAvailable
                />
            </div>
            <p className='w-full text-start'>{localizedStrings[titleKey]}</p>
        </li>
    );
};

export default WelcomePwaTipsItem;
